import { render, staticRenderFns } from "./ShopMemberDashboard.vue?vue&type=template&id=aeb4d904&"
import script from "./ShopMemberDashboard.vue?vue&type=script&lang=js&"
export * from "./ShopMemberDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports